export const formateCard = (card_number: number) => {
    const sCard = String(card_number)
    return `${sCard.slice(0, 4)} ${sCard.slice(4, 8)} ${sCard.slice(8, 12)} ${sCard.slice(12, 16)}`

}